
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UserADCell',
  props: {
    modelValue: { type: Boolean, default: false }
  }
});
